// src/data/processData.js (create if needed)
export const processSteps = [
    {
      number: '01',
      title: 'Brainstorming',
      description: 'We Brainstorm the creative ideas with a common approach method for finding new ideas, which is based on spontaneity and unfiltered creativity. We abide by No criticism, arguing, or negative comments in our Approach.',
    },
    {
      number: '02',
      title: 'Approaching',
      description: 'We identify the key processes and define the standards. We measure and evaluate the feasibility of the plan to bring maximum RoI. The approach is documented to achieve the desired quality with continuous room for improvement.',
    },
    {
      number: '03',
      title: 'Adjusting',
      description: 'With a swim lane diagram we assess the problems within the strategy and find the gap in Branding technique. Every bottle neck, cost restraint is closely picked and knocked out to avoid any delay in Branding process. We always follow A/B Testing for exquisite results.',
    },
    {
      number: '04',
      title: 'Result',
      description: 'With a Process Driven approach, the Branding restrictions are overcome and unfiltered creative ideas are put into action. The measuring of plan is continuously carried out to yield best results for the investments our Partners make.',
    },
  ];